import _ from 'lodash';
import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
// import Fuse from 'fuse.js';
import * as actions from '../../actions/memberActions';
import DropZone from '../../components/club/DropZone';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
import XLSX from 'xlsx';
import './upload.scss';
import './xlsx-shim';
import toastr from 'toastr';
import moment from 'moment-timezone';
import 'moment/locale/nb';
let image1 = require('./images/1.png');
let image2 = require('./images/2.png');
let image3 = require('./images/3.png');
let image4 = require('./images/4.png');
// import { Link } from 'react-router';

if (FileReader.prototype.readAsBinaryString === undefined) {
    FileReader.prototype.readAsBinaryString = function (fileData) {
      let binary = "";
      let pt = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        let bytes = new Uint8Array(reader.result);
        let length = bytes.byteLength;
        for (let i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        //pt.result  - readonly so assign content to another property
        pt.content = binary;
        $(pt).trigger('onload');
      };
      reader.readAsArrayBuffer(fileData);
    };
}


class UploadMembers extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.parseFiles = this.parseFiles.bind(this);
    this.updateSelect = this.updateSelect.bind(this);
    this.sheetOptions = this.sheetOptions.bind(this);
    this.columnOptions = this.columnOptions.bind(this);
    this.checkRequiredField = this.checkRequiredField.bind(this);
    this.checkEmail = this.checkEmail.bind(this);
    this.checkBirthday = this.checkBirthday.bind(this);
    this.valueField = this.valueField.bind(this);
    this.sendImport = this.sendImport.bind(this);
    this.state = {
      loading: false,
      sheetNames: [],
      settings: {},
      arrangedWorksheet: [],
      workbook: {},
      modelFields: {},
    };
  }

  componentDidMount() {
    let dropZone = document.getElementById('drop-zone');
    dropZone.addEventListener("dragenter",function(e){
      e = e || event;
      e.preventDefault();
    },false);

    dropZone.addEventListener("dragover",function(e){
      e = e || event;
      e.preventDefault();
    },false);
    dropZone.addEventListener('drop', this.handleDrop, false);
  }

  handleFile(e) {
    let files = e.target.files;
    this.parseFiles(files);
  }

  handleDrop(e) {
    e.stopPropagation();
    e.preventDefault();
    let files = e.dataTransfer.files;
    this.parseFiles(files);
  }

  parseFiles(files) {
    let i,f;
    let workbook;
    for (i = 0, f = files[i]; i != files.length; ++i) {
      let reader = new FileReader();
      // let name = f.name;
      reader.onload = (e) => {
        let data = !e ? reader.content : e.target.result;
        /* if binary string, read with type 'binary' */
        workbook = XLSX.read(data, {type: 'binary'});
        this.setState({
          workbook,
          selectedSheet: null,
          settings: {},
        });
      };
      reader.readAsBinaryString(f);
    }
  }

  updateSelect(values, target) {
    let settings = objectAssign({}, this.state.settings);
    settings[target] = values ? values.value : null;
    this.setState({
      settings: settings,
    });
  }

  updateSheetSelect(values) {
    let settings = this.state.settings;
    if (this.state.selectedSheet != values.value) {
      settings = {};
    }
    let worksheet = this.state.workbook.Sheets[values.value];
    let arrangedWorksheet = XLSX.utils.sheet_to_json(worksheet, {cellDates: true});
    let headerRow = _.keys(arrangedWorksheet[0]);
    let exampleRow = arrangedWorksheet[0];
    this.setState({
      selectedSheet: values.value,
      settings: settings,
      arrangedWorksheet: arrangedWorksheet,
      headerRow: headerRow,
      exampleRow: exampleRow,
    });
  }

  sheetOptions() {
    let sheetOptions = _.map(this.state.workbook.SheetNames, (name) => {
      return {value: name, label: name};
    });
    return sheetOptions;
  }

  columnOptions() {
    let columnOptions;
    if (this.state.selectedSheet) {
      columnOptions = this.state.headerRow.map((header) => {
        // alreadySelected = _.has(this.state.settings, {})
        return {value: header, label: header, disabled: false};
      });
      return columnOptions;
    }
  }

  checkBirthday() {
    let dateRegEx = /^\d{4}-\d{2}-\d{2}$/;
    let norDateRegEx = /^\d{2}.\d{2}.\d{4}$/;
    let allApproved = _.every(this.state.arrangedWorksheet, (row) => {
      let birthday = row[this.state.settings.birth_date];
      if (!birthday) {
        return false;
      } else if (birthday.match(dateRegEx) != null) {
        return true;
      } else if (birthday.match(norDateRegEx) != null) {
        return true;
      } else {
        return false;
      }
    });
    if (!allApproved) {
      return (<div className="alert alert-danger">
        {'Datoformatet ble ikke godkjent over alle rader. Kontroller excel arket'}
      </div>);
    } else {
      return false;
    }
  }

  checkEmail() {
    let emailRegEx = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    let allApproved = _.every(this.state.arrangedWorksheet, (row) => {
      let email = row[this.state.settings.email];
      return (!email || email.match(emailRegEx) != null);
    });
    if (!allApproved) {
      return (<div className="alert alert-danger">
        {'Ikke alle eposter er godkjent. Kontroller excel arket.'}
      </div>);
    } else {
      return false;
    }
  }

  checkRequiredField(field) {
    let allApproved = _.every(this.state.arrangedWorksheet, (row) => {
      return !!row[this.state.settings[field]];
    });
    if (!allApproved) {
      return (<div className="alert alert-danger">
        {'Ikke alle feltene er fylt ut. Kontroller excel arket.'}
      </div>);
    } else {
      return false;
    }
  }

  valueField(label, field, checkOk) {
    return (
      <div className="form-group col-sm-4">
        <label htmlFor="selectedSheet">
          {label}
        </label>
        <Select
          name={field}
          value={this.state.settings[field]}
          clearable={true}
          onChange={(value) => {
            this.updateSelect(value, field);
          }}
          options={this.columnOptions()}
          />
        <div className="help-block">
          {'Første rad: '}
          <strong>
            {this.state.exampleRow && this.state.exampleRow[this.state.settings[field]]}
          </strong>
          {checkOk}
        </div>
      </div>
    );
  }

  sendImport(approved) {
    if (!approved) {
      toastr.error('Kontroller at alle felter er gyldige');
      return false;
    } else if(this.state.loading || _.isEmpty(this.state.arrangedWorksheet)) {
      return false;
    }
    this.setState({
      loading: true,
    });
    let invertedSettings = _.invert(this.state.settings);
    let norDateRegEx = /^\d{2}.\d{2}.\d{4}$/;
    let importArray = this.state.arrangedWorksheet.map((row) => {
      let result = {club: Number(this.props.clubId)};
      _.forEach(this.state.settings, (key) => {
        if (invertedSettings[key] == 'birth_date' && (row[key].match(norDateRegEx) != null)) {
          let date = moment(row[key], "DD.MM.YYYY").format("YYYY-MM-DD");
          result[invertedSettings[key]] = date;
        } else {
          result[invertedSettings[key]] = row[key];
        }
      });
      return result;
    });
    this.props.actions.importMembers(this.props.clubId, importArray);
  }

  render() {
    let hasData = _.isEmpty(this.state.workbook);
    let firstNameApproved = this.checkRequiredField('first_name');
    let lastNameApproved = this.checkRequiredField('last_name');
    let birthdayApproved = this.checkBirthday();
    let emailApproved = this.checkEmail();
    let allApproved = _.every([
      !firstNameApproved,
      !lastNameApproved,
      !birthdayApproved,
      !emailApproved], (item) => {
      return item;
    });
    return (
      <div className="container">
        <div className="panel panel-default">
          <div className="panel-heading">
            <h4>Guide:</h4>
          </div>
          <div className="panel-body">
            <p>For å kunne importere en medlemsliste kan du gjøre følgende ENTEN eksportere medlemsliste i Excel fra KlubbAdmin/Medlemsnett e.l. ELLER klippe og lime og sette sammen en egen medlemsliste i Excel.</p>

            <p>
              <strong>Formatet skal være slik (bilde 1) og det er viktig å påse at formateringen på fødselsdato står slik DD.MM.YYYY (f.eks. 31.12.2000)</strong>.
              <img src={image4} className="img-responsive"alt=""/>
            </p>

            <div className="page-header">
              <h4>For å hente ut medlemsinformasjon fra KlubbAdmin gjør du slik:</h4>
            </div>
            <ol className="spaced-list">
            <li>
              <strong>Logg deg inn og klikk på Medlemsadministrasjon. (bilde 2)</strong>
              <br/>
              <img src={image1} className="img-responsive"alt=""/>
            </li>
            <li>
              <strong>Huk av for de medlemmene du ønsker å hente ut informasjon om og klikk så på Eksport. (bilde 3)</strong>
              <img src={image2}className="img-responsive" alt=""/>
            </li>
            <li>
              <strong>Her kan du velge hvilken informasjon som skal med, og vi trenger kun fornavn, etternavn og fødselsdato. Du kan derfor merke av de andre og klikke på pilen mot venstre for å fjerne de kolonnene. Klikk så på Eksport. (bilde 4)</strong>
              <br/>
              <img src={image3} className="img-responsive"alt=""/>
            </li>
            </ol>
            <br/>
            <p>Du har nå lastet ned medlemsinformasjonen i et exceldokument og kan starte importen i skjema under.</p>
          </div>
        </div>
        <div className="page-header">
          <h3>
            {'1. Last inn Excel fil '}
            {!hasData &&
              <FontAwesome name="check-circle" className="text-success"/>}
          </h3>
        </div>
        <label htmlFor="upload-file" className="center-block">
          <DropZone show={hasData} />
        </label>
        <input type="file" id="upload-file" onChange={this.handleFile} />
        <div>
          <div className="page-header">
            <h3>
              {'2. Velg ark (sheet) '}
              {this.state.selectedSheet &&
                <FontAwesome name="check-circle" className="text-success"/>}
            </h3>
          </div>
          <Select
            name="selectedSheet"
            value={this.state.selectedSheet}
            clearable={false}
            onChange={(value) => {
              this.updateSheetSelect(value, 'selectedSheet');
            }}
            options={this.sheetOptions()}
            />

          <div className="page-header">
            <h3>
              {'3. Velg kolonner: '}
              {allApproved && <FontAwesome name="check-circle" className="text-success"/>}
              {!allApproved && <FontAwesome name="times-circle" className="text-danger"/>}
            </h3>
          </div>
          <div className="alert alert-warning">
            <h5>
              {'Fornavn, etternavn og fødselsdato er påkrevd. Dvs. at de må velges og eksistere for alle medlemmer i arket.' +
                'Fødselsdato må være formatert slik: DD.MM.YYYY (Eksempel 14.05.2001).'}
            </h5>
            {'Velg felter fra excel arket. Dobbeltsjekk at du har valgt '+
              'riktige kolonner før du sender og lagrer medlemmene.'}
          </div>

          <div className="row">
            {this.valueField('Fornavn: *', 'first_name', firstNameApproved)}
            {this.valueField('Etternavn: *', 'last_name', lastNameApproved)}
            {this.valueField('Fødselsdato: *', 'birth_date', birthdayApproved)}
          </div>

          <div className="page-header">
            <h4>Valgfrie kolonner</h4>
          </div>
          <div className="row">
            {this.valueField('Telefonnummer: ', 'phone_number')}
            {this.valueField('Epost: ', 'email', emailApproved)}
            {this.valueField('Adresse: ', 'address')}
            {this.valueField('Kommune:', 'municipality')}
            {this.valueField('Fylke: ', 'county')}
            {this.valueField('Postnummer: ', 'zip')}
            {this.valueField('Land: ', 'country')}
          </div>

        </div>
        <button
          onClick={() => {
            this.sendImport(allApproved);
          }}
          className="btn btn-primary pull-right"
          disabled={!allApproved || this.state.loading || _.isEmpty(this.state.arrangedWorksheet)}
          >
          {!this.state.loading && <FontAwesome name="cloud-upload" />}
          {this.state.loading && <FontAwesome name="spinner" pulse />}
          {' Last opp'}
        </button>
      </div>
    );
  }
}

UploadMembers.propTypes = {
  actions: PropTypes.object.isRequired,
  memberList: PropTypes.array.isRequired,
  clubDetails: PropTypes.object.isRequired,
  clubDetailsUpdated: PropTypes.number,
  memeberDetailsUpdated: PropTypes.number,
  memberListUpdated: PropTypes.number,
  clubId: PropTypes.string.isRequired,
  loadingMembers: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    clubId: ownProps.params.clubId,
    memberList: state.clubs.memberList,
    clubDetails: state.clubs.clubDetails,
    clubDetailsUpdated: state.clubs.clubDetailsUpdated,
    memeberDetailsUpdated: state.clubs.memeberDetailsUpdated,
    memberListUpdated: state.clubs.memberListUpdated,
    loadingMembers: state.clubs.loadingMembers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadMembers);



/** WEBPACK FOOTER **
 ** ./src/containers/clubs/UploadMembers.js
 **/